import { MotherOrderList_orders_edges_node_subOrders } from "@saleor/motherOrders/types/MotherOrderList";
import * as React from "react";

interface BrandCellProps {
  subOrders: MotherOrderList_orders_edges_node_subOrders[];
}

const BrandCell: React.FC<BrandCellProps> = props => {
  const { subOrders } = props;

  return (
    <div
      style={{
        display: "inline-grid",
        overflow: "auto",
        overflowWrap: "break-word",
        wordBreak: "break-word"
      }}
    >
      {subOrders?.length !== 0
        ? subOrders?.map((e, index, array) => {
            if (array.length - 1 === index) {
              return (
                <span key={index} style={{ whiteSpace: "nowrap" }}>
                  {" "}
                  {e.tenant.brand.name}
                </span>
              );
            } else {
              return (
                <span key={index} style={{ whiteSpace: "nowrap" }}>
                  {e.tenant.brand.name},
                </span>
              );
            }
          })
        : "--"}
    </div>
  );
};

export default BrandCell;
